export default __webpack_public_path__ + "static/media/blob.left-md.0a44e840.png";